// import React, { useState } from 'react';
// import '../Component/product.css'
// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { Carousel } from 'react-responsive-carousel';
// import Zoom from 'react-medium-image-zoom';
// import 'react-medium-image-zoom/dist/styles.css';

// const ProductDetails = () => {
//     const [activeColor, setActiveColor] = useState('red');

//     const handleColorChange = (e) => {
//         setActiveColor(e.target.value);
//     };

//     return (
//         <main className="container" style={{
//             maxWidth: "90%",
//             margin: "0 auto",
//             padding: "15px",
//             display: "flex"
//         }}>
//             {/* Left Column */}
//             <div className="left-column">
//                 <div style={{ height: "100%", width: "95%" }}>
//                     <Carousel
//                         autoPlay
//                         infiniteLoop
//                         showThumbs={true}
//                         showStatus={false}
//                         showIndicators={false}
//                         showArrows={false}
//                         renderThumbs={() => [
//                             <img src="https://sleepycat.in/wp-content/uploads/2019/08/Hybrid-Latex_640-x-480_Image-02.jpg" alt="thumb1" />,
//                             <img src="https://sleepycat.in/wp-content/uploads/2019/08/Hybrid-Latex_640-x-480_Image-07.jpg" alt="thumb2" />,
//                             <img src="images/couch.png" alt="thumb3" />,
//                         ]}
//                     >
//                         <div>
//                             <Zoom>
//                                 <img src="https://sleepycat.in/wp-content/uploads/2019/08/Hybrid-Latex_640-x-480_Image-02.jpg" alt="slide1" />
//                             </Zoom>
//                         </div>
//                         <div>
//                             <Zoom>
//                                 <img src="https://sleepycat.in/wp-content/uploads/2019/08/Hybrid-Latex_640-x-480_Image-07.jpg" alt="slide2" />
//                             </Zoom>
//                         </div>
//                         <div>
//                             <Zoom>
//                                 <img src="images/couch.png" alt="slide3" />
//                             </Zoom>
//                         </div>
//                     </Carousel>
//                 </div>
//             </div>

//             {/* Right Column */}
//             <div className="right-column">
//                 {/* Product Description */}
//                 <div className="product-description">
//                     <h4>Original Mattress</h4>
//                     {/* <h1>Beats EP</h1> */}
//                     <p>
//                         Enjoy blissful sleep with the perfect balance of comfort & support. AirGen™ Memory Foam for enhanced breathability. The Original Mattress is not too soft, not too firm – it’s just right!
//                     </p>
//                 </div>

//                 {/* Product Configuration */}
//                 <div className="product-configuration">
//                     {/* Product Color */}
//                     {/* Cable Configuration */}
//                     <div className="cable-config">
//                         <span>Category</span>
//                         <div className="cable-choose">
//                             <button>Single</button>
//                             <button>Double</button>
//                             <button>King</button>
//                             <button>Queen</button>
//                             <button>Custom Size</button>
//                         </div>
//                     </div>

//                     <div className="cable-config">
//                         <div className='d-flex align-iems-center justify-content-between'>
//                         <span>Height</span>
//                         <span>How to select height?</span>
//                         </div>
//                         <div className="cable-choose">
//                             <button>6 inch</button>
//                             <button>8 inch</button>
//                             <button>10 inch</button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Product Pricing */}
//                 <div className="product-price">
//                     <span>₹ 148</span>
//                     <a href="#" className="cart-btn">Add to cart</a>
//                 </div>
//             </div>
//         </main>
//     );
// };

// export default ProductDetails;


import React, { useState } from 'react';
import '../Component/product.css';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import ReactImageMagnify from 'react-image-magnify';

const ProductDetails = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [isCustom, setIsCustom] = useState(false);
    const [selectedHeight, setSelectedHeight] = useState('');
    const [length, setLength] = useState('');
    const [width, setWidth] = useState('');

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    const handleCategoryClick = (type) => {
        if (type === 'custom') {
            setIsCustom(true);
            setSelectedHeight('');
            setLength('');
            setWidth('');
        } else {
            setIsCustom(false);
        }
    };

    return (
        <main className="container" style={{
            maxWidth: "90%",
            margin: "0 auto",
            padding: "15px",
            display: "flex"
        }}>
            {/* Left Column */}
            <div className="left-column">
                <div style={{ height: "90%", width: "95%" }}>
                    <Carousel
                        autoPlay
                        infiniteLoop
                        showThumbs={true}
                        showStatus={false}
                        showIndicators={false}
                        showArrows={false}
                        renderThumbs={() => [
                            <img src="https://sleepycat.in/wp-content/uploads/2020/12/Original_640-x-480_Image-01.jpg" alt="thumb1" />,
                            <img src="https://sleepycat.in/wp-content/uploads/2019/08/Hybrid-Latex_640-x-480_Image-07.jpg" alt="thumb2" />,
                            <img src="https://sleepycat.in/wp-content/uploads/2020/12/Original_640-x-480_Image-02.jpg" alt="thumb3" />,
                        ]}
                        width={700}
                    >
                        <div>
                            <ReactImageMagnify {...{
                                smallImage: {
                                    alt: 'slide1',
                                    isFluidWidth: true,
                                    src: 'https://sleepycat.in/wp-content/uploads/2020/12/Original_640-x-480_Image-01.jpg',
                                },
                                largeImage: {
                                    src: 'https://sleepycat.in/wp-content/uploads/2020/12/Original_640-x-480_Image-01.jpg',
                                    width: 1000,
                                    height: 1500
                                },
                                enlargedImagePosition: 'beside',
                                lensStyle: { backgroundColor: 'rgba(0,0,0,.3)' }
                            }} />
                        </div>
                        <div>
                            <ReactImageMagnify {...{
                                smallImage: {
                                    alt: 'slide2',
                                    isFluidWidth: true,
                                    src: 'https://sleepycat.in/wp-content/uploads/2019/08/Hybrid-Latex_640-x-480_Image-07.jpg',
                                },
                                largeImage: {
                                    src: 'https://sleepycat.in/wp-content/uploads/2019/08/Hybrid-Latex_640-x-480_Image-07.jpg',
                                    width: 1000,
                                    height: 1500
                                },
                                enlargedImagePosition: 'beside',
                                lensStyle: { backgroundColor: 'rgba(0,0,0,.3)' }
                            }} />
                        </div>
                        <div>
                            <ReactImageMagnify {...{
                                smallImage: {
                                    alt: 'slide3',
                                    isFluidWidth: true,
                                    src: 'https://sleepycat.in/wp-content/uploads/2020/12/Original_640-x-480_Image-02.jpg',
                                },
                                largeImage: {
                                    src: 'https://sleepycat.in/wp-content/uploads/2020/12/Original_640-x-480_Image-02.jpg',
                                    width: 1000,
                                    height: 1500
                                },
                                enlargedImagePosition: 'beside',
                                lensStyle: { backgroundColor: 'rgba(0,0,0,.3)' }
                            }} />
                        </div>
                    </Carousel>

                </div>
            </div>

            {/* Right Column */}
            <div className="right-column">
                <div className="product-description">
                    <h4>Original Mattress</h4>
                    <p>
                        Enjoy blissful sleep with the perfect balance of comfort & support. AirGen™ Memory Foam for enhanced breathability. The Original Mattress is not too soft, not too firm – it’s just right!
                    </p>
                </div>

                <div className="product-configuration">
                    {/* Category */}
                    <div className="cable-config">
                        <span>Category</span>
                        <div className="cable-choose">
                            <button onClick={() => handleCategoryClick('single')}>Single</button>
                            <button onClick={() => handleCategoryClick('double')}>Double</button>
                            <button onClick={() => handleCategoryClick('king')}>King</button>
                            <button onClick={() => handleCategoryClick('queen')}>Queen</button>
                            <button onClick={() => handleCategoryClick('custom')}>Custom Size</button>
                        </div>

                        {/* Custom Size Inputs */}
                        {isCustom && (
                            <div className="custom-inputs-inline">
                                <input
                                    type="number"
                                    placeholder="Length (in)"
                                    value={length}
                                    onChange={(e) => setLength(e.target.value)}
                                    style={{ width: "20px" }}
                                />
                                <input
                                    type="number"
                                    placeholder="Width (in)"
                                    value={width}
                                    onChange={(e) => setWidth(e.target.value)}
                                    style={{ width: "20px" }}
                                />
                                <input
                                    type="text"
                                    value={selectedHeight}
                                    placeholder="Height"
                                    readOnly
                                    style={{ width: "20px" }}
                                />
                            </div>
                        )}
                    </div>

                    {/* Height Section */}
                    <div className="cable-config">
                        <div className='d-flex align-items-center justify-content-between'>
                            <span>Height</span>
                            <span style={{ color: 'blue', cursor: 'pointer' }} onClick={togglePopup}>How to select height?</span>
                        </div>
                        <div className="cable-choose">
                            {[6, 8, 10].map(height => (
                                <button key={height} onClick={() => setSelectedHeight(`${height} inch`)}>
                                    {height} inch
                                </button>
                            ))}
                        </div>

                        {selectedHeight && !isCustom && (
                            <div className="selected-height">Selected Height: {selectedHeight}</div>
                        )}
                    </div>
                </div>

                <div className='d-flex align-items-center justify-content-between'>
                    <div className="product-price">
                        <span>₹ 10548</span>
                        <a href="#" className="cart-btn">Add to cart</a>
                    </div>

                    <div class="checkbox-wrapper-43">
                        With Cover&nbsp;&nbsp;<input type="checkbox" id="cbx-43" />
                        <label for="cbx-43" class="check">
                            <svg width="18px" height="18px" viewBox="0 0 18 18">
                                <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>
                                <polyline points="1 9 7 14 15 4"></polyline>
                            </svg>
                        </label>
                    </div>
                </div>
            </div>

            {/* Height Help Popup */}
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup">
                        <button className="close-btn fs-4" onClick={togglePopup}>❌</button>
                        <h3>How to select height?</h3>
                        <p>For total sleeper weight less than 60kgs, use a 6-inch (15.24cm) mattress</p>
                        <p>For total sleeper weight between 60-80kgs, use an 8-inch (20.32cm) mattress</p>
                        <p>For total sleeper weight above 80kgs, use a 10-inch (25.4cm) mattress</p>
                    </div>
                </div>
            )}
        </main>
    );
};

export default ProductDetails;